import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Checkbox,
	Popover,
	Chip,
	Tooltip
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range, groupBy } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA, NumberFieldA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import { SelectA, TextFieldA } from "../../components/form";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CallIcon from "@mui/icons-material/Call";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { array, number } from "prop-types";
import AddAgent from "./add-agent";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import useModalState from "../../../hooks/use-modal-state";

import { toast } from 'react-hot-toast';
import FullScreenLoader from "../caller/components/fullscreen-loader";


const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);
const weekday = require("dayjs/plugin/weekday");
dayjs.extend(weekday);

const API_HOST = CONFIG.modules["accounts"].host;

const noOfweeks = 10;
// const startRange = dayjs();
// console.log('start', startRange.format('DD-MM-YYYY WW'))

const items = {
	"Shift Management": {
		name: "Shift Management",
		view: "",
	},
};

const getWeekOfMonth = (date) => {
	let adjustedDate = date.getDate() + date.getDay();
	let prefixes = ['0', '1', '2', '3', '4', '5'];
	return (parseInt(prefixes[0 | adjustedDate / 7]) + 1);
}

const getRange = (startRange, n) => {

	const from = startRange.add(7 * (n), "day");
	const to = startRange.add((7 * (n + 1)) - 1, "day");

	return { from, to };
};

const getCurrentMonday = (date) => {
	let i = 0;
	let current = date//dayjs()
	while (true) {
		const d = current.format('ddd');
		if (d == 'Mon') {
			break;
		}
		current = current.add(-1, 'day')
		i++
		if (i > 8) {
			break;
		}
	}
	return current
}

const getWeekCount = (from, to) => {
	let i = 1;
	let current = from
	while (true) {

		if (
			current.isAfter(to)
			||
			current.isSame(to)
		) {
			console.log('found', current.format('DD-MM-YYYY'), to.format('DD-MM-YYYY'))
			break;
		}
		current = current.add(7, 'day')
		i++
		if (i > 300) {
			console.log('exceeded')
			break;
		}
	}

	return i;
}

export const ShiftManagement = (props) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		TaskTypes,
		Campaigns,
		Shifts,
		map
	} = useSelector((state) => state.user || {});

	const [startRange, setStartRange] = useState(getCurrentMonday(dayjs()));
	const [weekNumber, setWeekNumber] = useState(getWeekOfMonth(startRange.toDate()));
	const [filter, setFilter] = useState({
		from: dayjs(),
		to: dayjs().add(30, 'day'),
	});
	const [weekLeft, setWeekLeft] = useState(getWeekCount(filter.from, filter.to));
	const userStore = useSelector((state) => state.user || {});
	const [userMap, setUserMap] = useState({});
	const [campaign, setCampaign] = useState("");
	const [active, setActive] = useState("Shift Management");
	const [campaignMap, setCampaignMap] = useState({});
	const [days, setDays] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const [shiftMap, setShiftMap] = useState({});
	const [selected, setSelected] = useState(null);
	const [openM, setOpenM] = useState(false);
	const [usersByScheduleMap, setUsersByScheduleMap] = useState({})


	// const [openUL, setOpenUL] = useState(false)
	const [anchorElUL, setAnchorElUL] = useState(null);
	const [anchorTemplate, setAnchorTemplate] = useState(null);
	const [anchorElULT, setAnchorUsertemplate] = useState(null);

	const [selectedScheduleForTemplating, setSelectedScheduleForTemplating] =
		useState(null);

	const [countChange, setCountChange] = useState(null);
	const [bufferLimitChange, setBufferLimitChange] = useState(null);

	/**
	 * Shift Allocations are the entities ShiftAndNumbers in the backend
	 * 
	 * It contains the limit and buffer data for each shift
	 */
	const [shiftAllocations, setShiftAllocations] = useState([]);

	/**
	 * Shift Allocations Map is the map of shiftAndNumber entities identified by the shift key.
	 * 
	 * So if the there is not limit and buffer set for a shift then there shouldn't exist a shiftAllocationMap[shift._id]
	 */
	const [shiftAllocationsMap, setShiftAllocationsMap] = useState({});


	const [selectedShiftAllocation, setSelectedAllocation] = useState(null);
	const [shiftUsers, setShiftUsers] = useState([]);
	const [selectShift, setSelectedShift] = useState(null);
	const [shiftUsersMap, setShiftUsersMap] = useState({});

	const [rangeData, setRangeData] = useState({});
	const [rangeDataDefault, setRangeDataDefault] = useState({});
	const [selectedShiftForRange, setSelectedShiftForRange] = useState(null);

	const [rangesOfshifts, setRangesOfshifts] = useState([]);
	const [rangesOfshiftsMap, setRangesOfshiftsMap] = useState([]);
	const [rangesByShift, setRangesByShift] = useState({});
	const [datesOfShifts, setDatesOfShifts] = useState({});
	const [selectedSlot, setSelectedSlot] = useState({});
	const [shiftUsersBySchedules, setShiftUsersBySchedules] = useState([]);
	const [shiftUsersBySchedulesMap, setShiftUsersBySchedulesMap] = useState([]);
	const [attendanceMap, setAttendanceMap] = useState({});
	const [hugeMap, setHugeMap] = useState({});
	const [groups, setGroups] = useState([]);

	// Loading State for updating user to an shift
	const [updatingUserInShift, setUpdatingUserInShift] = useState(false);

	// Loading State for getting shift Alloations
	const [loadingShiftAllocations, setLoadingShiftAllocations] = useState(false);

	// Loading State for getting ranges (scheudles)
	const [loadingRanges, setLoadingRanges] = useState(false);

	// Loading State for CRUD operation on ranges (Schedules) on a shift
	const [loadingCRUDOnRanges, setLoadingCRUDOnRanges] = useState(false);

	const [rangeAction, setRangeAction] = useState("add");

	const open = Boolean(anchorEl);
	const openUL = Boolean(anchorElUL);
	const openTemplate = Boolean(anchorTemplate);
	const openULT = Boolean(anchorElULT);

	useEffect(() => {
		if (selectedSlot && selectedSlot.from && selectedSlot.to) {
			fetchAttendanceByRange()
		}
	}, [selectedSlot])


	useEffect(() => {
		// console.log('mango===>', shiftUsersBySchedulesMap)
	}, [shiftUsersBySchedulesMap])

	useEffect(() => {
		if (startRange) {
			setWeekNumber(getWeekOfMonth(startRange.toDate()))
		}
	}, [startRange])

	// useEffect(()=>{
	// 	if(weekNumber) {
	// 		setWeekLeft(6-weekNumber)
	// 	}
	// }, [weekNumber])

	useEffect(() => {
		if (filter) {
			setStartRange(getCurrentMonday(filter.from))
			setWeekLeft(getWeekCount(filter.from, filter.to))
		}
	}, [filter])

	const fetchAttendanceByRange = () => {
		// console.log('gerting called')
		axios
			.get(
				API_HOST +
				"/get-attendance-by-range?relation=leaveRequest&from=" + encodeURIComponent(dayjs(selectedSlot.from).format("YYYY-MM-DD")) + '&to=' + encodeURIComponent(dayjs(selectedSlot.to).format("YYYY-MM-DD"))
			)
			.then((resp) => {
				console.log('resp received range', resp.data)
				if (resp.data && resp.data.success) {
					setAttendanceMap(
						resp.data.data.reduce((a, e) => {
							// console.log('data type',e)
							if (a[e.user] && (a[e.user].status == "leave" || a[e.user].status == "half-day")) {

							} else
								a[e.user] = e;
							return a;
						}, {})
					);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const fetchAttendance = () => {
		// console.log('gerting called')
		axios
			.get(
				API_HOST +
				"/attendance?forDate=" +
				encodeURIComponent(dayjs().format("YYYY-MM-DD"))
			)
			.then((resp) => {
				console.log('resp received', resp.data)
				if (resp.data && resp.data.success) {
					setAttendanceMap(
						resp.data.data.reduce((a, e) => {
							// console.log('data type',e)
							a[e.user] = e;
							return a;
						}, {})
					);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		fetchAttendance();
	}, []);

	const getGroups = () => {
		setGroups([])
		axios.get(API_HOST + `/groups?lead=${user._id}`)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setGroups(resp.data.groups)
				}
			})
			.catch((e) => {
				console.log(e);
			});
	}

	const doMap = () => {
		setHugeMap(
			Object.values(rangesByShift).reduce((a, e) => {
				// console.log(e)
				if (Array.isArray(e)) {
					for (const r of e) {
						const { from, to } = r;
						let i = 0;
						let current = dayjs(from);
						const target = dayjs(to);
						while (true) {
							a[current.format("DD-MM-YYYY")] = [];
							if (current.format("DD-MM-YYYY") == target.format("DD-MM-YYYY")) {
								// console.log("eork");
								break;
							}
							i++;
							if (i > 100) {
								break;
							}
							current = current.add(1, "day");
						}
					}
				}
				return a;
			}, {})
		);
	};


	useEffect(() => {
		if (Object.values(rangesByShift).length > 0) {
			doMap();
		}
	}, [rangesByShift]);

	useEffect(() => {
		console.log("templating", selectedScheduleForTemplating);
	}, [selectedScheduleForTemplating]);

	const getUsersBySchedules = (shift, selected) => {
		setShiftUsersBySchedules([]);
		axios
			.get(
				API_HOST +
				`/users-by-schedules?shift=${shift}&campaign=` +
				campaign +
				`&schedule=${selected}`
			)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setShiftUsersBySchedules(resp.data.data);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};
	useEffect(() => {
		if (Array.isArray(shiftUsersBySchedules)) {
			setShiftUsersBySchedulesMap(
				shiftUsersBySchedules.reduce((a, e) => {
					a[e.user] = e;
					return a;
				}, {})
			);
		}
	}, [shiftUsersBySchedules]);

	const getShiftRanges = () => {
		setLoadingRanges(true);
		axios
			.get(API_HOST + "/shift-ranges?campaign=" + campaign)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setRangesOfshifts(resp.data.ranges);
				}
			})
			.catch((e) => {
				console.log(e);
			}).finally(() => {
				setLoadingRanges(false);
			});
	};

	const getUsersOfAllSchedules = () => {
		axios
			.get(API_HOST + "/get-users-by-ranges?campaign=" + campaign)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setUsersByScheduleMap(resp.data.data.reduce((a, e) => {
						if (!a[e.schedule]) {
							a[e.schedule] = []
						}
						a[e.schedule].push(e)
						return a;
					}, {}))
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		// console.log('RS', rangesOfshifts)
		if (Array.isArray(rangesOfshifts)) {
			const grouped = groupBy(rangesOfshifts, "shift");
			for (const s in grouped) {
				grouped[s] = grouped[s].map((e) => {
					// console.log('ee',e.from)
					e.from = dayjs(e.from).format("YYYY-MM-DD");
					e.to = dayjs(e.to).format("YYYY-MM-DD");
					// console.log('pp', e.from)
					return e;
				});
			}
			// console.log(grouped)
			setRangesByShift(grouped);
			setRangesOfshiftsMap(
				rangesOfshifts.reduce((a, e) => {
					a[e._id] = e;
					return a;
				}, {})
			);
		}
	}, [rangesOfshifts]);

	useEffect(() => {
		const datesByShift = {};
		for (const k in rangesByShift) {
			// console.log(k)
			const dates = rangesByShift[k];
			datesByShift[k] = {};
			for (const d of dates) {
				let current = dayjs(d.from);

				const target = dayjs(d.to);
				let i = 0;
				while (true) {
					datesByShift[k][dayjs(current).format("YYYY-MM-DD")] = d._id;
					if (dayjs(current).isSame(dayjs(target)) || i > 1000) {
						break;
					}
					current = dayjs(current).add(1, "day");
					i++;
				}
			}
		}
		setDatesOfShifts(datesByShift);
	}, [rangesByShift]);

	const addRangeToShift = () => {
		if (selectedShiftForRange) {
			setLoadingCRUDOnRanges(true);
			axios
				.put(API_HOST + "/add-range-to-shift", {
					type: rangeAction,
					shift: selectedShiftForRange._id,
					from: dayjs(rangeData.from).format("YYYY-MM-DD"),
					to: dayjs(rangeData.to).format("YYYY-MM-DD"),
					id: selectedSlot ? selectedSlot._id : null,
					campaign,
				})
				.then((resp) => {
					if (resp.data && resp.data.success) {
						if (rangeAction == "add") {
							const newRanges = [...rangesOfshifts];
							newRanges.push({ ...resp.data.SR });
							setRangesOfshifts([...newRanges]);
						} else {
							const newRanges = [...rangesOfshifts];
							const index = newRanges.findIndex(
								(e) => e._id == selectedSlot._id
							);
							newRanges[index] = resp.data.data;
							setRangesOfshifts([...newRanges]);
						}

						setAnchorEl(null);
					}
				})
				.catch((e) => {
					console.log(e);
				}).finally(() => {
					setLoadingCRUDOnRanges(false);
				});
		}
	};

	const removeRangeFromShift = (id) => {
		// if(selectedShiftForRange) {
		setLoadingCRUDOnRanges(true);
		axios
			.put(API_HOST + "/add-range-to-shift", {
				type: "remove",
				id,
			})
			.then((resp) => {
				if (resp.data && resp.data.success) {
					const newRanges = [...rangesOfshifts];
					setRangesOfshifts(newRanges.filter((r) => r._id != id));
					setAnchorEl(null);
				}
			})
			.catch((e) => {
				console.log(e);
			}).finally(() => {
				setLoadingCRUDOnRanges(false);
			});
		// }
	};

	const addfromTemplate = (id) => {
		setAnchorUsertemplate(null);

		axios
			.get(
				API_HOST +
				`/users-by-schedules?campaign=` +
				campaign +
				`&schedule=${id}`
			)
			.then(async (resp) => {
				if (resp.data && resp.data.success) {
					if (Array.isArray(resp.data.data)) {
						const newList = [];
						for (const d of resp.data.data) {
							if (shiftUsersBySchedulesMap[d.user]) {
								console.log(shiftUsersBySchedulesMap[d.user]);
							} else {
								const data = await addUserToShift(d.user, false);
								if (data) {
									newList.push(data);
								}
							}
						}
						let newData = [...shiftUsersBySchedules];
						newData = [...newData, ...newList];
						setShiftUsersBySchedules(newData);
					}
				}
				setAnchorUsertemplate(null);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const getUsersByShifts = (shift) => {
		setShiftUsers([]);
		axios
			.get(API_HOST + `/shifts-users?shift=${shift}&campaign=` + campaign)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setShiftUsers(resp.data.usersByshifts);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		if (Array.isArray(shiftUsers)) {
			// console.log("tt", shiftUsers);
			setShiftUsersMap(
				shiftUsers.reduce((a, e) => {
					a[e.user] = e;
					return a;
				}, {})
			);
		}
	}, [shiftUsers]);

	// useEffect(() => {
	// 	axios
	// 		.get(API_HOST + `/shifts-users`)
	// 		.then((resp) => {
	// 			if (resp.data && resp.data.success) {
	// 				const users = resp.data.usersByshifts;
	// 				setUsersShiftMap(groupBy(users, "shift"));
	// 			}
	// 		})
	// 		.catch((e) => {
	// 			console.log(e);
	// 		});
	// }, []);

	useEffect(() => { }, [users]);

	const getShiftUsers = () => {
		setLoadingShiftAllocations(true);
		axios.get(API_HOST + "/shift-allocations?campaign=" + campaign)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setShiftAllocations(resp.data.shiftAllocations);
				}
			})
			.catch((e) => {
				console.log(e);
			}).finally(() => {
				setLoadingShiftAllocations(false);
			});
	};


	const loadingRangesAndAllocations = useMemo(() => {
		return loadingRanges || loadingShiftAllocations;
	}, [loadingRanges, loadingShiftAllocations]);

	useEffect(() => {
		if (Array.isArray(shiftAllocations)) {
			// console.log('jb', shiftAllocations)
			setShiftAllocationsMap(
				shiftAllocations.reduce((a, e) => {
					// console.log('dddd',e)
					a[e.shift] = e;
					return a;
				}, {})
			);
		}
	}, [shiftAllocations]);

	useEffect(() => {
		if (Campaigns) {
			setCampaignMap(
				Campaigns.reduce((a, c) => {
					a[c._id] = c;
					return a;
				}, {})
			);
			setCampaign(Campaigns[0]._id);
		}
	}, [Campaigns]);

	useEffect(() => {
		const current = dayjs();
		setDays(
			range(0, 10).map((r, i) => {
				return current.add(r, "day");
			})
		);

		// console.log('hi',dayjs().unix())
	}, []);

	useEffect(() => {
		if (Campaigns) {
			setCampaignMap(
				Campaigns.reduce((a, c) => {
					a[c._id] = c;
					return a;
				}, {})
			);
			setCampaign(Campaigns[0]._id);
		}
	}, [Campaigns]);

	useEffect(() => {
		if (campaign) {
			getShiftUsers();
			getShiftRanges();
			getUsersOfAllSchedules()
		}
	}, [campaign]);

	const handleUpdateShiftNumber = (s, value, i) => {
		let obj = shiftAllocationsMap[s._id];
		if (!obj) {
			obj = { shift: s._id, number: value };
		}

		setSelectedAllocation({ ...obj, number: value });
	};

	const handleUpdateBufferLimit = (s, value, i) => {
		let obj = shiftAllocationsMap[s._id];
		if (!obj) {
			obj = { shift: s._id, bufferLimit: value };
		}
		setSelectedAllocation({ ...obj, bufferLimit: value });
	};

	const saveShiftAllocation = (s, i) => {
		let obj = selectedShiftAllocation || {};
		axios
			.put(API_HOST + "/update-shifts", {
				shift: s._id,
				number: obj.number || 0,
				bufferLimit: obj.bufferLimit || 0,
				campaign,
			})
			.then((resp) => {
				if (resp.data && resp.data.success) {
					const allocations = [...shiftAllocations];
					if (allocations[i]) {
						allocations[i] = { ...resp.data.shiftAllocation };
					} else {
						allocations.push(resp.data.shiftAllocation);
					}
					setShiftAllocations([...allocations]);
					setSelectedAllocation(null);
					const allocationMap = { ...shiftAllocationsMap };
					allocationMap[s._id].number = resp.data.shiftAllocation.number;
					allocationMap[s._id].bufferLimit =
						resp.data.shiftAllocation.bufferLimit;
					setShiftAllocationsMap({ ...allocationMap });
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const addUsersToShift = async (users, save = true) => {
		return await new Promise((d) => {
			setUpdatingUserInShift(true);
			axios
				.put(API_HOST + "/update-shifts-users", {
					type: "add",
					shift: selectShift._id,
					users,
					campaign,
					schedule: selectedSlot._id,
				})
				.then((resp) => {
					if (resp.data && resp.data.success && save) {
						let newData = [...shiftUsersBySchedules];

						setShiftUsersBySchedules([...newData, ...resp.data.SUs]);
						getUsersOfAllSchedules()
					} else if (resp.data && resp.data.success) {
						d(resp.data.SU);
					}
					d();
				})
				.catch((e) => {
					console.log(e);
					d();
				}).finally(() => {
					setUpdatingUserInShift(false);
				});
		});
	};

	useEffect(() => {
		console.log('------------------------------->', users)
		console.log('------------------------------->', (users || []).filter((u) =>
			(u.roles || []).includes(process.env.REACT_APP_TELECALLER)
		))
	}, [users])

	const addUserToShift = async (user, save = true) => {
		return await new Promise((d) => {
			setUpdatingUserInShift(true);
			axios
				.put(API_HOST + "/update-shifts-users", {
					type: "add",
					shift: selectShift._id,
					user,
					campaign,
					schedule: selectedSlot._id,
				})
				.then((resp) => {
					if (resp.data && resp.data.success && save) {
						let newData = [...shiftUsersBySchedules];
						newData.push(resp.data.SU);
						setShiftUsersBySchedules(newData);
						getUsersOfAllSchedules()
					} else if (resp.data && resp.data.success) {
						d(resp.data.SU);
					}
					d();
				})
				.catch((e) => {
					console.log(e);
					d();
				}).finally(() => {
					setUpdatingUserInShift(false);
				});
		});
	};

	const saveAsTemplate = (data, id, type) => {
		axios
			.put(API_HOST + "/update-template", {
				id,
				type,
				data: data,
			})
			.then((resp) => {
				if (resp.data && resp.data.success) {
					const newRanges = [...rangesOfshifts];
					const index = newRanges.findIndex(
						(e) => e._id == selectedScheduleForTemplating._id
					);
					newRanges[index] = resp.data.SR;
					setRangesOfshifts([...newRanges]);
					setAnchorTemplate(null);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const removeUserFromShift = (id) => {
		setUpdatingUserInShift(true);
		axios
			.put(API_HOST + "/update-shifts-users", {
				type: "remove",
				id,
			})
			.then((resp) => {
				if (resp.data && resp.data.success) {
					let newData = [...shiftUsersBySchedules];
					setShiftUsersBySchedules(newData.filter((e) => e._id != id));
					getUsersOfAllSchedules()
				}
			})
			.catch((e) => {
				console.log(e);
			}).finally(() => {
				setUpdatingUserInShift(false);
			});
	};

	return (
		<>
		<FullScreenLoader open={loadingRangesAndAllocations} />
		<FullScreenLoader open={loadingCRUDOnRanges} />
			<Box>
				<Box sx={{ display: "flex", width: "15%", mt: 0 }}>
					{/* <SelectA field={
                        {
                            type: 'select',
                            label: 'Campaign',
                            option: { key: 'Campaigns', value: '_id', label: 'name' },
                            name: 'campaign'
                        }
                    } data={{ Campaigns }} onChange={(name, value, multiple) => {
                        setCampaign(value)
                    }} value={campaign} /> */}
				</Box>
			</Box>

			<ToolBar

				filters={[

					{
						field: {
							name: "from",
							type: "date",
							label: "From",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					{
						field: {
							name: "to",
							type: "date",
							label: "To",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
				]}
			/>

			<Box sx={{ display: "flex", mt: 2 }}>
				<Box sx={{ width: 230 }}>
					<Box
						sx={{
							height: "40px",
							width: 230,
							borderRadius: 1,
							border: "1px solid grey",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Typography
							variant="p"
							sx={{ fontSize: ".85em", fontWeight: "bold" }}
						>
							{"Shifts"}
						</Typography>
					</Box>
					{Array.isArray(Shifts) &&
						Shifts.map((s, i) => {
							let count = 0;
							let bufferLimit = 0;
							if (
								selectedShiftAllocation &&
								selectedShiftAllocation.shift === s._id
							) {
								count = selectedShiftAllocation.number;
								bufferLimit = selectedShiftAllocation.bufferLimit;
							} else if (shiftAllocationsMap[s._id]) {
								count = shiftAllocationsMap[s._id].number || 0;
								bufferLimit = shiftAllocationsMap[s._id].bufferLimit || 0;
							}

							return (
								<Box
									key={i}
									sx={{
										width: 230,
										height: 160,
										borderRadius: 1,
										border: "1px solid grey",
										display: "flex",
										flexDirection: "column",
										justifyContent: 'center',
										py: 4
									}}
								>
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
											// width: "50%",
										}}
									>
										<Typography
											sx={{
												color: shiftAllocationsMap[s._id] ? "green" : "red",
												fontSize: ".8em",
												fontWeight: "bold",
												textAlign: "center",
												mt: 1,
											}}
										>
											{shiftAllocationsMap[s._id] ?
												null
												:
												"update the limit and buffer."
											}
										</Typography>
										<Typography
											variant="p"
											sx={{ fontSize: ".85em", fontWeight: "bold" }}
										>
											{s.name}
										</Typography>
										<Typography
											variant="p"
											sx={{ fontSize: ".6em" }}
										>{` (${dayjs(s.start).format("hh:mm:A")}-${dayjs(
											s.end
										).format("hh:mm:A")})`}</Typography>
										{/* <Button onClick={() => {
                                            getUsersByShifts(s._id)
                                            setOpenM(true)
                                            setSelectedShift(s)
                                        }}>Agents</Button> */}
									</Box>
									<Box
										sx={{
											// width: "50%",
											mt: 1,
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
											// borderLeft: "1px solid grey",
											// padding: 1,
										}}
									>
										<Box
											sx={{
												display: "flex",
												// flexDirection: "column",
												alignItems: "center",
											}}
										>
											{/* <CallIcon sx={{ fontSize: "1em" }} /> */}
											<NumberFieldA
												field={{
													label: "Limit",
													type: "number",
													name: "number",
													noMb: true,
												}}
												value={count}
												onChange={(name, value, multiple, index) => {
													setCountChange(`${i}`);
													handleUpdateShiftNumber(s, value, i);
												}}
												sxx={{
													// padding: "5px",
													width: "100px",
												}}
											/>
											<NumberFieldA
												field={{
													label: "Buffer",
													type: "number",
													name: "bufferLimit",
													noMb: true,
												}}
												value={bufferLimit}
												onChange={(name, value, multiple, index) => {
													setBufferLimitChange(`${i}`);
													handleUpdateBufferLimit(s, value, i);
												}}
												sxx={{
													paddingLeft: "5px",
													width: "100px",
												}}
											/>
										</Box>
										{(countChange == `${i}` || bufferLimitChange == `${i}`) && (
											<Box sx={{ display: "flex", mt: 0 }}>
												<Button
													onClick={() => {
														setCountChange(null);
														setBufferLimitChange(null);
														saveShiftAllocation(s, i);
													}}
												>
													save
												</Button>
												<Button
													onClick={() => {
														setSelectedAllocation(null);
														setBufferLimitChange(null);
														setCountChange(null);
													}}
												>
													Cancel
												</Button>
											</Box>
										)}
										{/* 
										{bufferLimitChange == `${i}` && (
											<Box sx={{ display: "flex" }}>
												<Button
													onClick={() => {
														setBufferLimitChange(null);
														saveShiftAllocation(s, i);
													}}
												>
													save
												</Button>
												<Button
													onClick={() => {
														setSelectedAllocation(null);
														setBufferLimitChange(null);
													}}
												>
													Canel
												</Button>
											</Box>
										)} */}
									</Box>
								</Box>
							);
						})}
				</Box>

				<Box sx={{ display: 'flex', overflow: "scroll", width: '100%' }}>
					<Box sx={{ width: 1000, }}>
						<Box
							sx={{
								width: "fit-content",
								height: "40px",
								borderRadius: 1,
								border: ".4px solid grey",
								display: "flex",
							}}
						>
							{range(0, weekLeft).map((n, i) => {
								const { from, to } = getRange(startRange, n);
								const months = {};
								let m = from.format("MMM");
								months[m] = m;
								m = to.format("MMM");
								months[m] = m;
								return (
									<Box
										key={i}
										sx={{
											borderRight: "1px solid grey",
											width: 560,
											height: "40px",
											display: "flex",
											justifyContent: "center",
											// alignItems: 'center',
											flexDirection: "column",
											padding: 0.5,
										}}
									>
										<Box sx={{ display: "flex", justifyContent: "center" }}>
											<Typography sx={{ fontSize: ".8em", fontWeight: "bold" }}>
												Week {getWeekOfMonth(from.toDate())} {`(${Object.values(months).join("/")})`}
											</Typography>
										</Box>
										<Box
											sx={{
												display: "flex",
												justifyContent: "space-between",
												height: 28,
											}}
										>
											{range(0, 7).map((n, i) => {
												return (
													<Box key={i} sx={{ textAlign: "center" }}>
														<Typography sx={{ fontSize: ".5em" }}>
															{from.add(n, "day").format("DD-MM-YYYY")}
														</Typography>
														<Typography sx={{ fontSize: ".5em" }}>
															{from.add(n, "day").format("ddd")}
														</Typography>
													</Box>
												);
											})}
										</Box>
									</Box>
								);
							})}
						</Box>
						{Array.isArray(Shifts) &&
							Shifts.map((s, i) => {
								return (
									<Box
										key={i}
										sx={{
											width: "fit-content",
											height: 160,
											borderRadius: 1,
											border: ".4px solid grey",
											display: "flex",
										}}
									>
										{range(0, weekLeft).map((n, i) => {
											const { from, to } = getRange(startRange, n);
											const getBooked = () => {
												let count = 0;
												let left = null;
												let selected = false;
												range(0, 7).forEach((n) => {
													const current = dayjs(from.add(n, "day")).format(
														"YYYY-MM-DD"
													);

													if (
														datesOfShifts[s._id] &&
														datesOfShifts[s._id][current]
													) {
														selected = datesOfShifts[s._id][current];
														if (left === null) {
															left = n;
														}

														count++;
													}
												});
												return { count, left, selected };
											};
											const { count, left, selected } = getBooked();
											// console.log(s._id, getBooked())
											return (
												<Box
													key={i}
													sx={{
														borderRight: "1px solid grey",
														width: 560,
														display: "flex",
														position: "relative",
													}}
												>
													{count > 0 && (
														<Box
															sx={{
																ml: `${left * 80}px`,
																width: count * 80,
																background: !(to.isAfter(dayjs()) || to.isSame(dayjs())) ? '#f9e5e1' : usersByScheduleMap[selected]?.length > 0 ? "#bfe7c8" : "#f1f6f2",
																display: "flex",
																flexDirection: "column",
																justifyContent: "space-between",
																padding: ".2em",
																border: ".5px solid grey",
															}}
														>
															<Box
																sx={{
																	display: "flex",
																	justifyContent: "space-between",
																}}
															>
																<Box sx={{ textAlign: "center" }}>
																	<Typography sx={{ fontSize: ".6em" }}>
																		{from.add(left, "day").format("DD-MM-YYYY")}
																	</Typography>
																	<Typography sx={{ fontSize: ".5em" }}>
																		{from.add(left, "day").format("ddd")}
																	</Typography>
																</Box>
																{(to.isAfter(dayjs()) || to.isSame(dayjs())) &&
																	<Box>
																		<EditIcon
																			color="#1077D9"
																			sx={{ cursor: "pointer", fontSize: "1.3em" }}
																			onClick={(e) => {
																				setSelectedShiftForRange(s);
																				setRangeDataDefault({
																					from: dayjs(from),
																					to: dayjs(to),
																				});
																				setRangeData({
																					from: dayjs(
																						rangesOfshiftsMap[selected].from
																					),
																					to: dayjs(rangesOfshiftsMap[selected].to),
																				});
																				setRangeAction("edit");
																				setAnchorEl(e.currentTarget);
																				setSelectedSlot(
																					rangesOfshiftsMap[selected]
																				);
																			}}
																		/>
																		{rangesOfshiftsMap[selected] &&
																			rangesOfshiftsMap[selected].templated && (
																				<BookmarkIcon
																					color="#1077D9"
																					sx={{
																						cursor: "pointer",
																						fontSize: "1.3em",
																					}}
																					onClick={(e) => {
																						setSelectedScheduleForTemplating(
																							rangesOfshiftsMap[selected]
																						);
																						setAnchorTemplate(e.currentTarget);
																					}}
																				/>
																			)}
																		{rangesOfshiftsMap[selected] &&
																			!rangesOfshiftsMap[selected].templated && (
																				<BookmarkBorderIcon
																					color="#1077D9"
																					sx={{
																						cursor: "pointer",
																						fontSize: "1.3em",
																					}}
																					onClick={(e) => {
																						setSelectedScheduleForTemplating(
																							rangesOfshiftsMap[selected]
																						);
																						setAnchorTemplate(e.currentTarget);
																					}}
																				/>
																			)}

																		<ClearIcon
																			color="#1077D9"
																			sx={{ cursor: "pointer", fontSize: "1.3em" }}
																			onClick={(e) => {
																				removeRangeFromShift(selected);
																			}}
																		/>
																	</Box>
																}
															</Box>
															<Box
																sx={{ display: "flex", justifyContent: "center", flexDirection: 'column', alignItems: 'center' }}
															>
																<Button
																	onClick={() => {
																		if (to.isAfter(dayjs()) || to.isSame(dayjs())) {

																			// Need to check if the shiftAllocationsMap contain this shift id
																			const shiftAllocation = shiftAllocationsMap[s._id];
																			if (!shiftAllocation) {
																				toast.error("Please assign a limit and buffer for this shift", {
																					duration: 3000,
																					icon: "🚨",
																					style: {
																						borderRadius: '10px',
																						background: '#333',
																						color: '#fff',
																					},
																					position: "top-center"
																				});
																				console.log("No shift allocation found", s);
																				return;
																			} else {
																				console.log("Shift allocation found", shiftAllocation);
																			}

																			setSelectedSlot(rangesOfshiftsMap[selected]);
																			getUsersBySchedules(s._id, selected);
																			setOpenM(true);
																			setSelectedShift(s);
																			getGroups()
																		}
																	}}
																>
																	Agents ({(usersByScheduleMap[selected] || []).filter(u => !u.swapped)?.length || 0})
																</Button>
																<AvatarGroup total={(usersByScheduleMap[selected] || []).filter(u => !u.swapped)?.length || 0}>
																	{
																		((usersByScheduleMap[selected] || []).filter(u => !u.swapped)).map((e, i) => {
																			return <Tooltip key={i} title={map.users[e.user]?.name} placement="bottom">
																				<Avatar sx={{ cursor: 'pointer' }} alt={map.users[e.user]?.name} src="/static/images/avatar/1.jpg" />
																			</Tooltip>
																			// return 
																		})
																	}


																</AvatarGroup>
															</Box>
															<Box
																sx={{
																	display: "flex",
																	flexDirection: "row-reverse",
																}}
															>
																<Box sx={{ textAlign: "center" }}>
																	<Typography sx={{ fontSize: ".6em" }}>
																		{from
																			.add(left + count - 1, "day")
																			.format("ddd")}
																	</Typography>

																	<Typography sx={{ fontSize: ".6em" }}>
																		{from
																			.add(left + count - 1, "day")
																			.format("DD-MM-YYYY")}
																	</Typography>
																</Box>
															</Box>
														</Box>
													)}
													{count == 0 && (to.isAfter(dayjs()) || to.isSame(dayjs())) && (
														<Box sx={{ width: 560 }}>
															<Box
																sx={{
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "center",
																	height: 160,
																}}
															>
																<AddCircleIcon
																	color="#1077D9"
																	sx={{ cursor: "pointer" }}
																	aria-describedby={"shift"}
																	onClick={(e) => {
																		setRangeDataDefault({
																			from: dayjs(from),
																			to: dayjs(to),
																		});
																		setRangeData({
																			from: dayjs(from),
																			to: dayjs(to),
																		});
																		setAnchorEl(e.currentTarget);
																		setRangeAction("add");
																		setSelectedShiftForRange(s);
																	}}
																/>
															</Box>
														</Box>
													)}
												</Box>
											);
										})}

									</Box>
								);
							})}
					</Box>
				</Box>
			</Box>

			<Popover
				id={"shift"}
				open={open}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				<Box sx={{ padding: 2, borderRadius: 2 }}>
					<FormA
						fields={[
							{
								type: "date",
								label: "From",
								required: true,
								name: "from",
								defaultValue: dayjs(),
								shouldDisableDate: (d) => {
									return (
										dayjs(d).isBefore(rangeDataDefault.from) ||
										dayjs(d).isAfter(rangeData.to)
									);
								},
							},
							{
								type: "date",
								label: "To",
								required: true,
								name: "to",
								defaultValue: dayjs(),
								shouldDisableDate: (d) => {
									return (
										dayjs(d).isBefore(rangeData.from) ||
										dayjs(d).isAfter(rangeDataDefault.to)
									);
								},
							},
						]}
						data={{}}
						onChange={(name, value, multiple) => {
							const newRange = { ...rangeData };
							newRange[name] = dayjs(value);
							setRangeData(newRange);
						}}
						state={rangeData}
					/>
					<Button
						onClick={() => {
							setAnchorEl(null);
						}}
					>
						Cancel
					</Button>
					<Button
						onClick={() => {
							addRangeToShift();
						}}
					>
						{rangeAction == "add" ? "Add" : "Save"}
					</Button>
				</Box>
			</Popover>

			<Modal
				open={openM}
				handleClose={() => {
					setOpenM(false);
				}}
				// head={
				// 	selectShift
				// 		? `Agents in ${selectShift.name} (${dayjs(selectShift.start).format(
				// 				"hh:mm:A"
				// 		  )}-${dayjs(selectShift.end).format("hh:mm:A")}) | Capacity : ${
				// 				Array.isArray(shiftUsersBySchedules) &&
				// 				shiftUsersBySchedules.length > 0 &&
				// 				shiftAllocationsMap
				// 					? shiftUsersBySchedules.length *
				// 					  shiftAllocationsMap[selectShift._id].number
				// 					: ""
				// 		  } `
				// 		: `Agents in Shift 5 (02:00:AM-10:00:AM)`
				// }
				buttons={[
					{
						name: "Close",
						onClick: () => {
							setOpenM(false);
						},
					},
				]}
			>

				<AddAgent selectedSlot={selectedSlot} groups={groups} selectShift={selectShift}
					addUsersToShift={addUsersToShift}
					removeUserFromShift={removeUserFromShift}
					shiftUsersBySchedulesMap={shiftUsersBySchedulesMap}
					attendanceMap={attendanceMap}
					addUserToShift={addUserToShift}
					users={users}
					openUL={openUL}
					anchorElUL={anchorElUL}
					setAnchorElUL={setAnchorElUL}
					shiftUsersBySchedules={shiftUsersBySchedules}
					shiftAllocationsMap={shiftAllocationsMap}
					campaign={campaign}
					updatingUserInShift={updatingUserInShift}
				/>
				{false && selectedSlot && selectedSlot.from && (
					<Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
						<Box
							sx={{
								textAlign: "center",
								border: ".5px solid grey",
								padding: 1,
								borderRadius: 1,
							}}
						>
							<Typography sx={{ fontSize: ".7em" }}>
								{dayjs(selectedSlot.from).format("DD-MM-YYYY")}
							</Typography>
							<Typography sx={{ fontSize: ".7em" }}>
								{dayjs(selectedSlot.from).format("ddd")}
							</Typography>
						</Box>
						<Typography variant="p">&nbsp; to &nbsp;</Typography>
						<Box
							sx={{
								textAlign: "center",
								border: ".5px solid grey",
								padding: 1,
								borderRadius: 1,
							}}
						>
							<Typography sx={{ fontSize: ".7em" }}>
								{dayjs(selectedSlot.to).format("DD-MM-YYYY")}
							</Typography>
							<Typography sx={{ fontSize: ".7em" }}>
								{dayjs(selectedSlot.to).format("ddd")}
							</Typography>
						</Box>
					</Box>
				)}
				{false && Array.isArray(users) &&
					users
						.filter((u) => shiftUsersBySchedulesMap[u._id])
						.map((u, i) => {
							let onLeave = false;
							if (
								attendanceMap[u._id] &&
								attendanceMap[u._id].status == "leave" &&
								attendanceMap[u._id] &&
								attendanceMap[u._id].leaveRequest
							) {
								onLeave = attendanceMap[u._id].leaveRequest;
								onLeave.from = dayjs(dayjs(onLeave.from).format('YYYY-MM-DD'))
								onLeave.to = dayjs(dayjs(onLeave.to).format('YYYY-MM-DD'))
								// console.log('hi there',u.name)
								// console.log(onLeave.from.format('DD-MM-YYYY HH:mm:ss'), dayjs(selectedSlot.from).format('DD-MM-YYYY HH:mm:ss'))
								// console.log(onLeave.to.format('DD-MM-YYYY HH:mm:ss'), dayjs(selectedSlot.to).format('DD-MM-YYYY HH:mm:ss'))
							}
							return (
								<Box key={i} sx={{ mb: 0.5, display: "flex" }}>
									<Box
										sx={{
											padding: "4px 10px 4px 10px",
											borderRadius: 1,
											border: ".5px solid grey",
											display: "flex",
											width: "80%",
										}}
									>
										<Typography variant="p">{u.name}</Typography>


										{onLeave && ((dayjs(onLeave.from).isAfter(dayjs(selectedSlot.from)) || dayjs(onLeave.from).isSame(dayjs(selectedSlot.from))) && (dayjs(onLeave.to).isBefore(dayjs(selectedSlot.to)) || dayjs(onLeave.to).isSame(dayjs(selectedSlot.to)))) && (
											<Chip
												sx={{ ml: 1 }}
												label={`On Leave (${dayjs(onLeave.from).format(
													"DD/MM/YYYY"
												)}-${dayjs(onLeave.to).format("DD/MM/YYYY")})`}
												size="small"
												color={"error"}
												variant="outlined"
											/>
										)}
									</Box>
									<Box>
										{selectedSlot.to && (dayjs(selectedSlot.to).isAfter(dayjs()) || dayjs(selectedSlot.to).isSame(dayjs())) &&
											<>
												&nbsp;
												<RemoveCircleIcon
													sx={{ cursor: "pointer" }}
													onClick={() => {
														removeUserFromShift(
															shiftUsersBySchedulesMap[u._id]._id
														);
													}}
												/>
											</>
										}
									</Box>
								</Box>
							);
						})}
				{
					false && selectedSlot.to && (dayjs(selectedSlot.to).isAfter(dayjs()) || dayjs(selectedSlot.to).isSame(dayjs())) &&

					<Box sx={{ display: "flex" }}>
						<Button
							aria-describedby={"users-list"}
							onClick={(e) => {
								setAnchorUsertemplate(e.currentTarget);
							}}
						>
							Add from templates
						</Button>
						<Button
							aria-describedby={"users-list"}
							sx={{ ml: 1 }}
							onClick={(e) => {
								setAnchorElUL(e.currentTarget);
							}}
						>
							Add more +{" "}
						</Button>
					</Box>
				}
			</Modal>



			{/* <Popover
				id={"users-list"}
				open={openUL}
				anchorEl={anchorElUL}
				onClose={() => setAnchorElUL(null)}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				<List>
					{Array.isArray(users) &&
						users
							.filter((u) =>
								(u.roles || []).includes(process.env.REACT_APP_TELECALLER)
							)
							// .filter((u) => !shiftUsersBySchedulesMap[u._id])
							.map((u, i) => {
								return (
									<ListItem key={i} disablePadding>
										<ListItemButton>
											<ListItemText
												primaryTypographyProps={{ fontSize: ".8em" }}
												primary={`${u.name}`}
												onClick={() => {
													addUserToShift(u._id);
												}}
											/>
										</ListItemButton>
									</ListItem>
								);
							})}
				</List>
			</Popover> */}

			<Popover
				id={"users-list-template"}
				open={openULT}
				anchorEl={anchorElULT}
				onClose={() => setAnchorUsertemplate(null)}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				<List>
					{Array.isArray(rangesOfshifts) &&
						rangesOfshifts
							.filter((t) => t.templated)
							.map((u, i) => {
								return (
									<ListItem key={i} disablePadding>
										<ListItemButton>
											<ListItemText
												primaryTypographyProps={{ fontSize: ".8em" }}
												primary={`${u.name}`}
												onClick={() => {
													addfromTemplate(u._id);
												}}
											/>
										</ListItemButton>
									</ListItem>
								);
							})}
				</List>
			</Popover>

			<Popover
				id={"save-template"}
				open={openTemplate}
				anchorEl={anchorTemplate}
				onClose={() => setAnchorTemplate(null)}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				<Box sx={{ padding: 2, borderRadius: 2 }}>
					{selectedScheduleForTemplating && (
						<>
							<Box>
								<Chip
									label={`${dayjs(selectedScheduleForTemplating.from).format(
										"DD-MM-YYYY"
									)}`}
									variant="outlined"
								/>{" "}
								to &nbsp;
								<Chip
									label={`${dayjs(selectedScheduleForTemplating.to).format(
										"DD-MM-YYYY"
									)}`}
									variant="outlined"
								/>
							</Box>
							<TextFieldA
								field={{
									type: "text",
									label: "Template Name",
									required: true,
									name: "name",
								}}
								data={{}}
								onChange={(name, value, multiple) => {
									setSelectedScheduleForTemplating({
										...selectedScheduleForTemplating,
										name: value,
									});
								}}
								value={selectedScheduleForTemplating.name || ""}
								sxx={{ mt: 2 }}
								state={{}}
							/>
							<Button
								onClick={() => {
									setAnchorTemplate(null);
								}}
							>
								Cancel
							</Button>
							<Button
								onClick={() => {
									saveAsTemplate(
										{ name: selectedScheduleForTemplating.name },
										selectedScheduleForTemplating._id,
										"save"
									);
								}}
							>
								Save
							</Button>
							<Button
								onClick={() => {
									saveAsTemplate(
										{ name: selectedScheduleForTemplating.name },
										selectedScheduleForTemplating._id,
										"unsave"
									);
								}}
							>
								Unsave
							</Button>
						</>
					)}
				</Box>
			</Popover>
		</>
	);
};
